import {useState, useEffect} from 'react';
import styled from 'styled-components';

import {useNavigate, useLocation, Navigate, Link} from 'react-router-dom';
import {useAuth} from '../../../contexts/UserContext';
import config from '../../../config';
import {SubInner} from '../../atoms/CommonParts';
import {useApp} from '../../../contexts/AppContext';
import './style.scss';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';

const Page = styled.div``;

const TopLabel = styled.div`
  
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #000000;
  margin-bottom: 40px;
  @media ${config.layout.wide} {
    text-align: center;  
  }
`;

const InputFieldLabel = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;

  h4 {
    span {
      font-size: 14px;
      font-weight: bold;
      line-height: 19px;
    }
  }
`;

const InputField = styled.input`
  display: block;
  width: 100%;
  font-size: 18px;
  padding: 8px 15px !important;
  background-color: #fff;
  border-radius: 4px;
`;

const ErrorMessage = styled.div`
  border: 1px solid #FF7323;
  border-radius: 2px;
  font-size: 14px;
  line-height: 29px;
  text-align: left;
  padding: 20px 25px;
  font-weight: bold;
  margin-bottom: 40px;
  @media ${config.layout.wide} {
    text-align: center;
  }

  a {
    color: #cb0e0e;
    text-decoration: underline;
  }
`;

const DontHaveOne = styled.div`
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;

  a {
    color: #000000;
  }
`;

export default function ForgotVenueCodePage() {
  const location = useLocation();
  const {hideHeader} = useApp();

  const auth = useAuth();
  const [completed, setCompleted] = useState(false);
  const [errorElm, setErrorElm] = useState('');
  const [errorFieldSet, setErrorFieldSet] = useState(new Set());

  let defaultValues = (location.state && location.state.initial_params) || {
    email: '',
  };
  let defaultError = (location.state && location.state.error) || null;
  let fromRegistration = false;

  const searchParams = new URLSearchParams(window.location.search);
  let from = '/';
  if (location.state && location.state.from) {
    from =
        `${location.state.from.pathname || ''}${
            location.state.from.search || ''
        }` || '/';
  }
  if (searchParams.has('from')) {
    from = searchParams.get('from');
  }
  if (from && /^\/registration/.test(from)) {
    fromRegistration = true;
  }
  console.log('from', from, fromRegistration);

  useEffect(() => {
    document.title = 'Forgot KUVO ID';
    hideHeader();
    setCompleted(false);
    if (defaultError) {
      setErrorByCode(defaultError);

      try {
        let st = window.history.state;
        delete st.usr.error;
        window.history.replaceState(st, document.title);
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  function setErrorByCode(code) {
    switch (code) {
      default:
        setErrorElm(<span>Unknown error. Please retry later.</span>);

        break;
      case 401041:
        setErrorElm(
            <span>
            This e-mail address is not registered for KUVO. Please try the e-mail address registered to your AlphaTheta Account.
          </span>,
        );
        //setErrorFieldSet(new Set(["email", "password"]));
        break;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    let formData = new FormData(event.currentTarget);
    let email = formData.get('email');

    auth.requestVenueCode(email, (err) => {
      setErrorElm('');
      setErrorFieldSet(new Set());
      if (err) {
        const status = (err.response && err.response.status) || 500;
        const code =
            (err.response && err.response.data && err.response.data.code) ||
            500;

        setErrorByCode(code);

        console.error(err.response, status, code);
      } else {
        setCompleted(true);
        //  navigate(from, { replace: true });
      }
    });
  }

  return (
      <Page>
        <NotLoginedHeaderArea/>

        <TopLabel>
          {completed
              ? 'The venue code has been sent to the registered e-mail address.'
              : 'Enter the e-mail address registered to your AlphaTheta Account that you used for your KUVO venue account.'}
        </TopLabel>

        <SubInner>
          {!completed ? (
              <>
                {errorElm ? <ErrorMessage>{errorElm}</ErrorMessage> : ''}

                <form onSubmit={handleSubmit}>
                  <InputFieldLabel>
                    <h4>
                      <span>E-mail address</span>
                    </h4>
                  </InputFieldLabel>

                  <InputField
                      name="email"
                      type="email"
                      className={errorFieldSet.has('email')
                          ? 'error'
                          : 'normal'}
                      required
                      defaultValue={defaultValues.email || ''}
                      autoComplete="email"
                  />

                  <button
                      type="submit"
                      className="dark-button center-fixed primary"
                      style={{
                        margin: '40px auto 40px',
                      }}
                  >
                    <span>Send</span>
                  </button>

                  <DontHaveOne>
                    <span>Forgotten your e-mail address?</span>
                    <span className="pc"> </span>
                    <br className="sp"/>
                    <Link
                        to="/contact/"
                        state={{
                          category: 'Forgot my e-mail to resend the KUVO ID',
                        }}
                    >
                      Contact us.
                    </Link>
                  </DontHaveOne>
                </form>
              </>
          ) : (
              <>
                {fromRegistration ? (
                    <Link
                        className="dark-button back-button center-fixed primary"
                        to={from}
                        state={{
                          add: 1,
                        }}
                        style={{}}
                    >
                      <span>Go back to login</span>
                    </Link>
                ) : (
                    <Link
                        className="dark-button back-button center-fixed primary"
                        to={`/?from=${encodeURIComponent(from)}`}
                        style={{}}
                    >
                      <span>Go back to login</span>
                    </Link>
                )}
              </>
          )}
        </SubInner>
      </Page>
  );
}
